import Student from './Student';
import Preference from './Preference';

interface GroupData {
    id?: number;
    name: string;
    group_code: string;
    students?: Student[];
    preferences?: Preference[];
}

class Group {
    id?: number;
    name: string;
    group_code: string;
    students: Student[];
    preferences: Preference[];

    constructor(data: GroupData) {
        this.id = data.id;
        this.name = data.name;
        this.group_code = data.group_code;
        this.students = data.students || [];
        this.preferences = data.preferences || [];
    }

    // Static method to create a Group instance from raw API data
    static fromApiData(data: any): Group {
        return new Group({
            id: data.id,
            name: data.name,
            group_code: data.group_code,
            students: data.students?.map((s: any) => Student.fromApiData(s)) || [],
            preferences: data.preferences?.map((p: any) => {
                // Check if this is already a Preference instance
                if (p instanceof Preference) {
                    return p;
                }
                // Check if this has camelCase fields (already processed)
                if (p.startTime !== undefined || p.endTime !== undefined) {
                    return new Preference({
                        id: p.id,
                        owner_type: p.ownerType || p.owner_type,
                        owner_id: p.ownerId || p.owner_id,
                        institution_id: p.institutionId || p.institution_id,
                        day: p.day,
                        start_time: p.startTime || p.start_time,
                        end_time: p.endTime || p.end_time,
                        status: p.status,
                        createdAt: p.createdAt,
                        updatedAt: p.updatedAt
                    });
                }
                // Otherwise, treat as raw API data
                return new Preference(p);
            }) || []
        });
    }

    // Static method to create multiple Group instances from raw API data
    static fromApiDataArray(dataArray: any[]): Group[] {
        return dataArray.map(data => Group.fromApiData(data));
    }
}

export default Group; 